import { MapPin, Phone } from "lucide-react";
import { scrollToSection, telHref } from "@/lib/scroll";
import { useSettings } from "@/lib/SettingsContext";

export default function Footer() {
  const settings = useSettings();

  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-[#0B1D16] pt-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-12 border-b border-[#1E3B30] pb-16 md:grid-cols-3">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#D4AF37]">Contact</p>
            <a
              data-testid="footer-phone"
              href={telHref(settings.phone_display)}
              className="mt-4 flex items-center gap-2 text-lg font-semibold text-[#FAF8F5] transition-colors duration-300 hover:text-[#D4AF37]"
            >
              <Phone className="h-4 w-4" strokeWidth={1.75} />
              {settings.phone_display}
            </a>
            <a
              data-testid="footer-email"
              href={`mailto:${settings.email}`}
              className="mt-2 block text-sm text-[#FAF8F5]/60 transition-colors duration-300 hover:text-[#D4AF37]"
            >
              {settings.email}
            </a>
            <p className="mt-4 flex items-start gap-2 text-sm leading-relaxed text-[#FAF8F5]/60">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#D4AF37]" strokeWidth={1.75} />
              Don Sparkle Cleaning, {settings.address}, Essex, UK
            </p>
            <p className="mt-2 text-sm text-[#FAF8F5]/60">{settings.hours}</p>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#D4AF37]">Service Areas</p>
            <ul className="mt-4 space-y-2">
              {(settings.areas || []).map((a) => (
                <li key={a} className="text-sm text-[#FAF8F5]/60">{a}</li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#D4AF37]">Explore</p>
            <ul className="mt-4 space-y-2">
              {[
                ["Services", "#services"],
                ["Pricing", "#pricing"],
                ["Our Standard", "#manifesto"],
                ["Reviews", "#reviews"],
                ["Careers", "#careers"],
                ["Book Now", "#booking"],
              ].map(([label, hash]) => (
                <li key={hash}>
                  <button
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                    onClick={() => scrollToSection(hash)}
                    className="text-sm text-[#FAF8F5]/60 transition-colors duration-300 hover:text-[#D4AF37]"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4 py-8">
          <p className="text-xs text-[#FAF8F5]/40">
            © {new Date().getFullYear()} Don Sparkle Cleaning. Fully insured · Harlow, Essex.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FAF8F5]/30">
            The Sparkle Standard
          </p>
        </div>
      </div>
      <div
        aria-hidden
        className="pointer-events-none select-none whitespace-nowrap text-center font-serif text-[18vw] font-light leading-[0.75] text-[#FAF8F5]/[0.04]"
      >
        Don Sparkle
      </div>
    </footer>
  );
}
